export default __webpack_public_path__ + "static/media/c14.5da72609.jpg";